import { store } from '@redux/store';
import Typeahead from '@components/typeahead/geoLocationtypeahead';
import { locationIconSvg } from 'constants/svg-assets';
import { searchParametersActions } from 'features/searchResultsFacets';

const parser = new DOMParser();
export const locationIconSvgElement = parser.parseFromString(locationIconSvg, 'image/svg+xml').documentElement;

const config = {
  searchInput: document.getElementById('srp_typeahead_input'),
  suggestionsContainer: document.getElementById('srp_typeahead_suggestions'),
  errorContainer: document.getElementById('srp_typeahead_error'),
  clearButton: document.querySelector('[data-typeahead-clear]'),
  currentLocation: {
    searchText: 'Current location',
    isEnabled: true,
    icon: `<div class='nhs-c-suggestion__icon-container'>${locationIconSvgElement.cloneNode(true).outerHTML}</div>`,
  },
};

const typeahead$ = Typeahead(config);

typeahead$.subscribe((suggestion) => {
  const payload = suggestion.dataset;
  delete payload.qa;

  if (suggestion.matches('[data-current-location-search]')) {
    return;
  }

  store.dispatch(searchParametersActions.fetchLocations(payload));
});

export default typeahead$;
